export default __webpack_public_path__ + "mobile_top_outlaw.5c6dea.png";